
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/multi-conversation/conversation-list",
      function () {
        return require("private-next-pages/x/react-chat/multi-conversation/conversation-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/multi-conversation/conversation-list"])
      });
    }
  